// extracted by mini-css-extract-plugin
export default {"searchField":"ArticleSearchField_searchField__-K0vL"};